import { ASSET_PREFIX } from 'utils/constants';
import Heart40Filled from '../svg/Heart40Filled.svg';
import Heart40 from '../svg/Heart40.svg';

interface IFavouriteButtonProps {
  favourited: boolean;
  onToggle: (newValue: boolean) => void;
  style?: React.CSSProperties;
  rebrand2025?: boolean;
}

const FavouriteButton = ({
  favourited,
  onToggle,
  style,
  rebrand2025 = false,
}: IFavouriteButtonProps) => {
  const ElementTagName = rebrand2025 ? 'button' : 'div';
  return (
    <ElementTagName
      className={'container' + (rebrand2025 ? ' rebrand2025' : '')}
      aria-label={
        rebrand2025
          ? favourited
            ? 'Remove from wish list'
            : 'Add to wish list'
          : undefined
      }
      style={style}
      onClick={(e) => {
        e.stopPropagation(); // Prevent onClick method of the containing PrizeCard being called.
        onToggle(!favourited);
      }}
    >
      {rebrand2025 ? (
        favourited ? (
          <Heart40Filled />
        ) : (
          <Heart40 />
        )
      ) : (
        <img
          src={`${ASSET_PREFIX}/images/prizes/favourite-heart${favourited ? '-filled' : ''}.svg`}
          className="icon"
        />
      )}

      <style jsx>{`
        .container {
          padding: 0.7em; // Increase the touch area
          margin: -0.7em;
          width: auto;
          -webkit-tap-highlight-color: transparent;
        }

        .rebrand2025 {
          background: none;
        }

        @media (min-width: 768px) {
          .container svg {
            width: 28px;
          }
        }

        .container :global(svg) {
          width: 40px;
        }

        .icon {
          display: block;
          width: 28px;
          height: 28px;
        }
      `}</style>
    </ElementTagName>
  );
};

export default FavouriteButton;
